import { u as useAppStateManager, A as AppProvider } from '../../dist/useAppStateManager-b600c5c5.esm.js';
import 'react';
import '../../dist/useCustomReducer-8da85d66.esm.js';

var AppStateManager = {
  useAppStateManager,
  AppProvider
};

export { AppStateManager as default };
